module.exports = __webpack_public_path__ + "img/no_review_icon.75b6c501.svg";